import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}


// Resolve media paths stored in DB into browser-safe URLs.
// Supports absolute URLs, /api/... backend assets, /stream, /thumbnail,
// and normal public/static paths.
export const resolveMediaUrl = (url, fallback = '') => {
  if (!url || typeof url !== 'string') {
    return fallback;
  }

  if (
    url.startsWith('http://') ||
    url.startsWith('https://') ||
    url.startsWith('data:') ||
    url.startsWith('blob:')
  ) {
    return url;
  }

  const backendUrl = process.env.REACT_APP_BACKEND_URL || '';

  if (
    url.startsWith('/api/') ||
    url.startsWith('/stream/') ||
    url.startsWith('/thumbnail/') ||
    url.startsWith('/webhook/')
  ) {
    return `${backendUrl}${url}`;
  }

  if (url.startsWith('/')) {
    return url;
  }

  return backendUrl ? `${backendUrl}/${url}` : `/${url}`;
};
